const modal = {
  namespaced: true,
  state: {
    modal: '',
    key1: null,
    key2: null,
    head1: '',
    head2: '',
    confirmHead1: '',
    confirmHead2: '',
    message1: '',
    message2: '',
    message3: '',
    message4: '',
    confirmMessage1: '',
    confirmMessage2: ''
  },
  getters: {
    getModal: (state) => state.modal,
    getKey1: (state) => state.key1,
    getKey2: (state) => state.key2,
    getHead1: (state) => state.head1,
    getHead2: (state) => state.head2,
    getConfirmHead1: (state) => state.confirmHead1,
    getConfirmHead2: (state) => state.confirmHead2,
    getMessage1: (state) => state.message1,
    getMessage2: (state) => state.message2,
    getMessage3: (state) => state.message3,
    getMessage4: (state) => state.message4,
    getConfirmMessage1: (state) => state.confirmMessage1,
    getConfirmMessage2: (state) => state.confirmMessage2
  },
  mutations: {
    setModal (state, modal) {
      state.modal = modal
    },
    setKey1 (state, key) {
      state.key1 = key
    },
    setKey2 (state, key) {
      state.key2 = key
    },
    setHead1 (state, head) {
      state.head1 = head
    },
    setHead2 (state, head) {
      state.head2 = head
    },
    setConfirmHead1 (state, head) {
      state.confirmHead1 = head
    },
    setConfirmHead2 (state, head) {
      state.confirmHead2 = head
    },
    setMessage1 (state, message) {
      state.message1 = message
    },
    setMessage2 (state, message) {
      state.message2 = message
    },
    setMessage3 (state, message) {
      state.message3 = message
    },
    setMessage4 (state, message) {
      state.message4 = message
    },
    setConfirmMessage1 (state, message) {
      state.confirmMessage1 = message
    },
    setConfirmMessage2 (state, message) {
      state.confirmMessage2 = message
    }
  },
  actions: {
    setModal ({ commit }, modal) {
      commit('setModal', modal)
    },
    setKey1 ({ commit }, key) {
      commit('setKey1', key)
    },
    setKey2 ({ commit }, key) {
      commit('setKey2', key)
    },
    setHead1 ({ commit }, head) {
      commit('setHead1', head)
    },
    setHead2 ({ commit }, head) {
      commit('setHead2', head)
    },
    setConfirmHead1 ({ commit }, head) {
      commit('setConfirmHead1', head)
    },
    setConfirmHead2 ({ commit }, head) {
      commit('setConfirmHead2', head)
    },
    setMessage1 ({ commit }, message) {
      commit('setMessage1', message)
    },
    setMessage2 ({ commit }, message) {
      commit('setMessage2', message)
    },
    setMessage3 ({ commit }, message) {
      commit('setMessage3', message)
    },
    setMessage4 ({ commit }, message) {
      commit('setMessage4', message)
    },
    setConfirmMessage1 ({ commit }, message) {
      commit('setConfirmMessage1', message)
    },
    setConfirmMessage2 ({ commit }, message) {
      commit('setConfirmMessage2', message)
    }
  }
}

export default modal



// WEBPACK FOOTER //
// ./src/vuex/modal.js